import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import { StylesProvider } from '@material-ui/core/styles';

import Routes from './Routes';
import { BrowserRouter } from 'react-router-dom';

import { SnackbarWrapper } from '@components';
import { GlobalStyle, Theme } from '@styles';

// Translations
import '@config/i18n.config';

// Interceptor HTTP 
import '@config/interceptor-http.config';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <StylesProvider injectFirst>
          <ThemeProvider theme={Theme}>
            <Routes />
            <SnackbarWrapper />
            <GlobalStyle />
          </ThemeProvider>
        </StylesProvider>
      </BrowserRouter>
    );
  }
}

export default App;